const pallets = {
    valentine: {
        fg: [7,8,9], 
        bg: [10,9,7], 
    },
    fruit_salad: {
        fg: [6,3,1],
        bg: [0,1,6], 
    },
    pinball_wizard: {
        fg: [0,5,4], 
        bg: [4,3,0], 
    },
    lime_smash: {
        fg: [2,3,4],
        bg: [5,6,2], 
    },
    pinky_pie: {
        fg: [0,1,2], 
        bg: [3,4,1],
    },
    citrus: {
        fg: [6,7,3],
        bg: [3,3,6],
    },
    purple_kiss: {
        fg: [0,18,12],
        bg: [12,14,18],
    },
    spearmint: {
        fg: [15,17,16],
        bg: [16,8,17],
    },
    orange_you_glad: {
        fg: [20,15,21],
        bg: [21,9,20],
    },
    battery_licker: {
        fg: [6,14,21],
        bg: [21,0,7],
    },
    planet_earth: {
        fg: [22,23,20],
        bg: [20,8,23]
    }
}


const colorRamps = [
    ['#5EF2F2','#F2059F'], // 0
    ['#FFEC5C','#BD45BF'], // 1
    ['#1C8394','#143333','#A0CD60'], // 2
    ['#FFEC5C','#FF5A33'], // 3
    ['#400036','#F2059F','#F23030'], // 4
    ['#1C8394','#2F1B47'], // 5
    ['#fafa6e','#5EF556'], // 6
    ['#A0CD60','#fafa6e'], // 7
    ['#1C8394','#5EF2F2'], // 8
    ['#F23030','#400036'], // 9
    ['#7B51A6','#A52502'], // 10
    ['#F2167D','#049DD9','#05C7F2'], // 11
    ['#404040','#1C1C1C'], // 12
    ['#042940','#9FC131','#DBF227'], // 13
    ['#F2059F', '#042940'], // 14
    ['#B4BEC9','#FFFFFF',], // 15
    ['#DEEFE7','#159A9C','#002333'], // 16
    ['#FFFFFF','#72F2EB'], // 17
    ['#4F1BBF', '#D91ACC', '#F294D9'], // 18,
    ['#98C1D9', '#293241' ], // 19
    ['#6BB3F2','#204796','#0320FF'], // 20
    ['#F23322','#f60'], // 21
    ['#1D5926','#328C40','#47A62D'], // 22
    ['#BFF205','#3BDB29'], // 23
]

export { pallets, colorRamps }
